var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wireless-box-view"},[(!_vm.empty)?[_c('status-bar',_vm._b({},'status-bar',_vm.status,false)),_c('sensorList',{attrs:{"list":_vm.seneorList}})]:[_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t('数据加载中')))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }